import React, { useState, useEffect } from 'react';
import { Pressable } from 'react-native';
import { Box, Text, View, useTheme } from 'native-base';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { faClose } from '@fortawesome/pro-regular-svg-icons';
const Banner = _ref => {
  let {
    topicId,
    topicIdList,
    type,
    refresh,
    close
  } = _ref;
  const theme = useTheme(),
    {
      colors
    } = theme;
  const msg = 'Click here to refresh and see new ' + (type === 'reply' ? 'replies' : 'posts');
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (topicIdList.includes(topicId)) {
      setShow(true);
    } else {
      setShow(false);
    }
  }, [topicIdList]);
  if (!show) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    my: 5,
    w: '100%',
    bg: colors.banner.bg,
    alignItems: 'center',
    justifyContent: 'center',
    h: 50
  }, /*#__PURE__*/React.createElement(Pressable, {
    onPress: () => {
      refresh(topicId);
    },
    style: {
      padding: '8px'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    fontWeight: 'bold',
    fontSize: {
      base: '0.9em',
      sm: '1.15em',
      md: '1.25em',
      lg: '0.95em'
    },
    color: colors.banner.text
  }, msg)), /*#__PURE__*/React.createElement(View, {
    position: 'absolute',
    right: 5,
    bg: colors.banner.close.bg,
    borderRadius: 8
  }, /*#__PURE__*/React.createElement(Pressable, {
    onPress: () => {
      close(topicId);
    },
    style: {
      padding: '8px'
    }
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faClose,
    color: colors.banner.close.icon
  }))));
};
export default Banner;
//# sourceMappingURL=Banner.js.map